import { useEffect, useCallback } from 'react';
import useApi from './useApi';
import { useAppSettings } from '../hooks/useAppSettings';
import { buildApiUrl } from '../utils/apiUtils';

export interface StowageRuleItem {
    id: number;
    name: string;
}

export default () => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();

    const getStowageRules = useCallback(async () => {
        try {
            const apiUrl = appSettings?.api;
            if (!apiUrl) {
                throw new Error('API URL not configured in app settings');
            }
            await getApiData({
                endpoint: buildApiUrl(apiUrl, '/GetStowageRules'),
            });
        } catch (error) {
            console.error('Failed to fetch stowage rules:', error);
        }
    }, [getApiData, appSettings]);

    useEffect(() => {
        if (state.status === 'success' && state.result) {
            try {
                console.log('Stowage Rules API Response:', state.result);
            } catch (error) {
                console.error('Error processing stowage rules:', error);
            }
        }
    }, [state.status, state.result]);

    const getStowageRulesData = (): StowageRuleItem[] => {
        if (state.status === 'success' && state.result) {
            let rawRules: any[] = [];
            if (Array.isArray(state.result)) {
                rawRules = state.result;
            } else if (state.result.data && Array.isArray(state.result.data)) {
                rawRules = state.result.data;
            } else if (typeof state.result === 'object') {
                rawRules = [state.result];
            }
            return rawRules.map((rule: any) => ({
                id: rule.id ?? rule.Id,
                name: rule.name ?? rule.Name,
            }));
        }
        return [];
    };

    return {
        stowageRules: getStowageRulesData(),
        loading: state.isLoading,
        error: state.error,
        getStowageRules,
        status: state.status,
    };
};
